module.exports = __webpack_public_path__ + "static/media/whatsapp_logo.7e924155.svg";